import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { stores } from 'stores';
import { observer } from 'mobx-react';
import { S } from './style';

const { ProfileStore } = stores;

export const MaintenaceModalDefault = observer(() => {
  const updateMetaData = () => {
    ProfileStore.updatePersonalInfo({
      hasSeenMaintenanceWarning: true,
    });
  };

  useEffect(() => {
    return () => {
      if (!ProfileStore.metaData.hasSeenMaintenanceWarning) {
        updateMetaData();
      }
    };
  }, []);
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.H>
        {t('maintenance.warning.header', 'Scheduled maintenance notice')}
      </S.H>
      <S.P>
        {t(
          'maintenance.warning.text',
          'Please note that you will be experiencing the platform downtime on 28th of Jan, 2023 from 23:00 to 06:00 of the next day. You will be still able to manage your deals via MetaTrader platform.'
        )}
      </S.P>
      <S.CloseIcon onClick={updateMetaData} />
    </S.Container>
  );
});
